module.exports = __webpack_public_path__ + "img/unimed-logo-1.6db0c397.png";